export default __webpack_public_path__ + "static/media/66.7cc2b946.gif";